import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Database } from "lucide-react";

export const DemoSeedCard = ({ onDone }) => {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const seed = async () => {
    setBusy(true);
    try {
      const r = await api.post("/admin/seed-demo");
      const c = r.data.counts || {};
      toast.success(`Voorbeelddata gevuld: ${c.tenants} debiteuren, ${c.properties} panden, ${c.complaints} klachten`);
      setDone(true);
      onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Vullen mislukt"); }
    setBusy(false);
  };
  if (done) return null;
  return (
    <div className="rounded-xl border-2 border-dashed border-emerald-300 bg-emerald-50/50 p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-testid="dashboard-demo-seed-card">
      <div>
        <h2 className="font-heading font-semibold text-slate-800">De werkruimte is nog leeg</h2>
        <p className="text-sm text-slate-600 max-w-xl">Vul met één klik voorbeelddata (opdrachtgevers, panden, debiteuren, contracten, betalingen, klachten en taken) om alles meteen te proberen. Wissen kan later via Instellingen → Demo &amp; testdata.</p>
      </div>
      <Button className="bg-emerald-600 hover:bg-emerald-700 shrink-0" onClick={seed} disabled={busy} data-testid="dashboard-demo-seed-button">
        <Database className="h-4 w-4 mr-2" /> {busy ? "Bezig met vullen…" : "Voorbeelddata vullen"}
      </Button>
    </div>
  );
};
